export default "__VITE_ASSET__cf0e464b__"